import { Route } from 'types/route.type';
import EditWelfareScoring from './components/edit-welfare-scoring';
import ListWelfareScoring from './list-welfare-scoring';

export const routes: Route[] = [
  {
    path: '/fish-check/welfare-scoring',
    component: ListWelfareScoring,
    id: 'fishCheck.navigation.listWelfareScoring',
  },
  {
    path: '/fish-check/welfare-scoring/:id',
    component: EditWelfareScoring,
  },
];
